/**
 * 中文
 */

export const lang = {
  // 头部
  header: {
    title: '智慧供电管理系统',
    projectTypes: '项目类型',
    projectName: '项目名',
    addProject: '新建项目',
    entryProject: '进入项目',
    backHome: '回到首页',
    warnNums: '告警设备数',
    warnProjects: '告警项目数',
    modifyUserInformation: '修改用户信息',
    changePassword: '修改密码',
    userManagement: '用户管理',
    agingTest: '老化测试',
    forcedDelete: '强制反激活',
    propertSettings: '属性设置',
    infraredAgingTest: '红外老化测试',
    authorizationManagement: '授权管理',
    logout: '退出登录',
    changeNickname: '修改昵称',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '确认密码',
    alarmList: '告警设备列表',
    viewAlarmContent: '查看告警内容',
    alarmContent: '告警内容',
    processingEquipment: '处理设备',
    noAlarmData: '无告警数据',
    alarmProjectList: '告警项目列表',
    doubleClickView: '双击查看告警设备',
    password: '密码',
    newProject: '新建项目',
    voucherCenter: '充值中心',
    autoLocation: '自动定位',
    positionType: '定位类型'
  },
  // 通用
  common: {
    welcome: '欢迎您',
    accountLogin: '账号密码登录',
    account: '账号',
    login: '登 录',
    cancel: '取 消',
    sure: '确 定',
    name: '名称',
    snName: 'sn号',
    pnName: 'pn号',
    submit: '保存',
    add: '新增',
    username: '用户名',
    roleName: '角色名',
    nickname: '昵称',
    operate: '操作',
    edit: '编辑',
    delete: '删除',
    searchDeviceName: '搜索设备名',
    deviceName: '设备名',
    state: '状态',
    updateTime: '更新时间',
    expiresTime: '过期时间',
    lng: '经度',
    lat: '纬度',
    owner: '拥有者',
    manager: '协作管理员',
    member: '一般成员',
    guest: '只读成员',
    proprietor: '业主',
    selectDate: '选择日期',
    startDate: '开始日期',
    endDate: '结束日期',
    startTime: '开始时间',
    endTime: '结束时间',
    createTime: '创建时间',
    loading: '正在努力加载中...',
    comfirmLogout: '确认退出登录?',
    setNoAlarm: '确认将该设备设置为不告警?',
    brightness: '亮度',
    switch: '开关',
    sunrise: '日出',
    sunset: '日落',
    remark: '备注',
    all: '全部',
    choose: '请选择',
    currentGroup: '当前分组',
    noDevices: '暂无设备',
    gotoAdd: '前往添加',
    cruuentDevicesNumber: '当前接入运行设备数量',
    showOfflineList: '点击查看离线设备列表',
    showPowerDowmList: '点击查看断电设备列表',
    showLightOutList: '点击查看灭灯设备列表',
    online: '在线',
    offline: '离线',
    alarm: '告警',
    lighting: '亮灯',
    dowmLight: '关灯',
    Electrify: '通电',
    powerFailure: '断电',
    solarPanels: '太阳能板',
    battery: '蓄电池',
    deviceStatus: '设备当前状态',
    update: '更新',
    power: '功率',
    voltage: '电压',
    current: '电流',
    offlineList: '离线设备列表',
    lightOutList: '灭灯设备列表',
    powerOffList: '断电设备列表',
    issuingInstruction: '正在下发指令...',
    open: '开',
    close: '关',
    dimming: '调光',
    charge: '充电',
    network: '网络',
    connectionMode: '连接模式',
    signalIntensity: '信号强度',
    batteryStatus: '电池状态',
    switchStatus: '开关状态',
    solar: '太阳能板',
    solarVoltage: '太阳能板电压',
    solarCurrent: '太阳能板电流',
    batteryVoltage: '蓄电池电压',
    batteryCurrent: '蓄电池电流',
    activeTime: '激活时间',
    check: '查看',
    updateState: '更新状态',
    bodyResponse: '人体感应',
    hybridSolarPowered: '市电互补',
    switchController: '开关控制器',
    deviceParamsInfo: '设备参数信息',
    command: '命令',
    infraredStatus: '红外通讯状态',
    strategyStatus: '策略状态',
    parameterStatus: '参数状态',
    details: '详情',
    more: '更多',
    currentStrategy: '当前策略',
    batteryType: '电池类型',
    LiFePO4: '磷酸铁锂',
    ternaryLithium: '三元锂',
    leadAcid: '铅酸',
    sodiumIon: '钠离子',
    colloid: '胶体',
    liquid: '液体',
    ratedCurrent: '额定电流',
    batteryVoltageMultiplier: '电池电压倍率',
    strongChargeVoltage: '强充电压',
    evenChargeVoltage: '均衡充电压',
    floatChargeVoltage: '浮充电压',
    overVoltage: '超压电压',
    overToBackVoltage: '电池超压恢复电压',
    lowVoltage: '电池低压电压',
    lowToBackVoltage: '电池低压恢复电压',
    dayThreshold: '光控天亮阈值',
    nightThreshold: '光控天黑阈值',
    chargeCapacity: '充电量',
    dischargeCapacity: '放电量',
    remainCapacity: '电池剩余容量',
    other: '其他',
    temperatures: '环境温度',
    voltageType: '电压类型',
    singleBattery: '电压类型',
    constantCurrent: '恒流控制器',
    hybridConstant: '市电互补恒流控制器',
    hybridSwitch: '市电互补开关控制器',
    solar4g: '4G太阳能网关',
    customizedController: '专用控制器',
    pvSolarController: '光伏并网',
    allUsers: '所有用户',
    PARTNER: '合作伙伴',
    CUSTOMER: '客户',
    ENDUSER: '最终用户',
    SALE: '销售经理',
    DEALER: '经销商',
    ENTERPRISE_ADMIN: '企业管理员',
    ENTERPRISE_SALE: '企业业务员',
    ENTERPRISE_CUSTOMER_L1: '企业一级客户',
    ENTERPRISE_CUSTOMER_L2: '企业二级客户',
    ENTERPRISE_CUSTOMER_L3: '企业三级客户',
    PROPRIETOR: '业主',
    creater: '创建人',
    systemName: '系统名称',
    unlock: '解锁',
    lock: '锁定',
    resetPassword: '重置密码',
    subsystem: '子系统',
    addUser: '新增用户',
    powerSupply: '供电',
    dimmingMode: '调光模式',
    signalValue: '信号值',
    weakest: '最弱',
    weak: '弱',
    general: '一般',
    stronger: '较强',
    strong: '强',
    noData: '暂无'
  },
  // 消息提示
  prompt: {
    passwordAgain: '请再次输入密码',
    disaccord: '两次输入密码不一致',
    inputNickname: '请输入昵称',
    inputNewPassword: '请输入新密码',
    maxLength5: '长度不能大于 5 个字符',
    maxLength16: '长度不能大于 32 个字符',
    snLength8: 'SN号为8位',
    inputOldPassword: '请输入旧密码',
    minLengthPassword: '密码6到16位',
    correctLngLat: '请输入正确的经度值',
    inputDeviceName: '请输入设备名称',
    noEmpty: '不能为空',
    success: '成功',
    warning: '警告',
    error: '错误',
    saveSuccess: '保存成功',
    deleteSuccess: '删除成功',
    noMatching: '无匹配角色名',
    tips: '提示',
    isDeleteUser: '确认删除该用户?',
    cancelled: '已取消',
    affectDisplay: '此操作将影响设备中心展示设备, 是否继续?',
    selectDevice: '请选择设备',
    noSetEnable: '正在使用的设备不可设置为启用',
    disableNoDisable: '已停用设备不可设置为停用',
    failedDevices: '操作失败的设备有：',
    isDeleteDevice: '此操作将永久删除设备, 是否继续？',
    useNoDelete: '正在使用的设备不可被删除',
    only4tags: '最多只能设置4个标签',
    exist: '已存在',
    followSuccess: '关注成功',
    noFollowSuccess: '取消关注成功',
    selectItem: '请选择项目',
    isDeleteStrategy: '此操作将永久删除该策略, 是否继续？',
    anyTime: '任意时间点',
    inputNumber: '请输入数字值',
    brightnessRange: '亮度范围 0 ~ 100',
    max6Periods: '最多6 个时间段',
    isOpenIntelligentPower: '开启智能功率，会自动根据电池情况将当前亮度乘以适当的百分比后下发，是否继续开启？',
    isDeleteGroup: '此操作将永久删除该分组, 是否继续?',
    selectGroup: '请选择分组',
    comfirmMove: '确定将设备移动到该分组?',
    fail: '失败',
    isGroupOpen: '此操作将对该分组里的设备发送开启指令, 是否继续?',
    isGroupClose: '此操作将对该分组里的设备发送关闭指令, 是否继续?',
    isGroupCharge: '此操作将对该分组里的设备发送充电指令, 是否继续?',
    isGroupPowerFailure: '此操作将对该分组里的设备发送断电指令, 是否继续?',
    isOpen: '此操作将发送开启指令, 是否继续?',
    isClose: '此操作将发送关闭指令, 是否继续?',
    brightnessNotEmpty: '亮度必填',
    supplyVoltageRange: '电源电压值应在9~30区间!',
    rangeBetween: '数值应该在以下区间',
    snFirst: '请先输入sn号',
    snErrorRules: 'sn号不符合规则',
    noRatedCurrent: '额定电流不能为空',
    checkSuccess: '校验成功，请再次将该文档上传至下方',
    locationNoEmpty: '请选择位置',
    alarmSolarPanel: '太阳能板异常',
    overvoltage: '过压保护',
    overCurrent: '过流保护',
    overUnderTemperature: '温度过高/过低保护',
    lowVoltage: '电池低压保护',
    highVoltage: '电池高压保护',
    shortCircuit: '短路保护',
    hardware: '硬件保护',
    errorCode: '通用错误码',
    userNameLength: '用户名长度3-16位',
    nickNameLength: '昵称长度2-10位',
    electricalNoEmpty: '用电设备名称不能为空',
    itemNameNoEmpty: '项目名称不能为空',
    timeLimit: '开始时间不能大于结束日期',
    timeRange: '日期范围不能超过3天',
    switchLanguageSuccess: '切换语言成功',
    timeRange14: '时间范围只能14天内',
    timeRange3Month: '时间范围只能3个月内',
    changeLocation: '所选设备位置将被更改，是否继续？',
    inputPositive: '请输入正整数'
  },
  // 导航菜单
  navbar: {
    equipmentCenter: '设备中心',
    monitoringCenter: '监控中心',
    alarmCenter: '告警中心',
    strategyCenter: '策略中心',
    groupManagemen: '分组管理',
    projectInformation: '项目信息'
  },
  // 项目信息
  projectInfo: {
    scanningLocation: '自动定位',
    concerned: '关注',
    notConcerned: '取消/无关注',
    electricalEquipment: '用电设备',
    owner: '拥有者',
    identity: '身份',
    projectLocation: '项目位置',
    tag: '标签',
    maxLength7: '最多7个字',
    projectPeople: '参与人数',
    addTags: '添加',
    management: '管理',
    equipmentQuantity: '设备数量',
    searchName: '搜索用户名',
    addProjectUsers: '增加项目用户',
    editProjectUsers: '编辑项目用户',
    managementEquipment: '管理设备',
    batchIncrease: '批量增加',
    batchDelete: '批量删除',
    enable: '启用',
    disable: '停用',
    downloadTemplate: '下载模板',
    modifyParameters: '修改参数',
    editDeviceInfo: '编辑设备信息',
    authenticate: '验证用户',
    addDevice: '增加设备',
    checkExcel: '校验Excel',
    DragFiles: '将文件拖到此处，或',
    clickUpload: '点击上传',
    uploadExcel: '上传Excel',
    noRolename: '无匹配角色名'
  },
  // 告警
  warn: {
    alarmState: '告警状态',
    alreadyRead: '已读',
    untreated: '未处理',
    alarmType: '告警类型',
    alarmLevel: '告警等级',
    processingState: '处理状态',
    alarmTime: '告警时间',
    alarmContent: '告警内容',
    solutionReference: '解决方案参考',
    today: '今天',
    yesterday: '昨天',
    aWeekAgo: '一周前',
    threeDayAgo: '三天前',
    checkSolar: '请检查太阳能接线是否正确，太阳能板是否被遮挡',
    checkDevice: '检查用电设备线是否正确，用电设备串并数是否合理',
    overCurrentProtection: '用电设备过流保护',
    checkCharge: '电池电量不足，请确认充电是否正常',
    checkWiring: '检查电池接线是否正确'
  },
  // 策略
  strategy: {
    strategyList: '策略列表',
    newStrategy: '新建策略',
    strategyName: '策略名称',
    intelligentPower: '智能功率',
    turnOnPower: '开启智能功率',
    lightControl: '光控',
    weatherControl: '天气控',
    turnOnLight: '开启光控',
    copyAdded: '复制新增',
    strategyInformation: '策略信息',
    stage: '阶段',
    addState: '增加时间阶段',
    time: '时间',
    tagAttribute: '标记属性',
    setReduceRatio: '设置降功比例'
  },
  // 监控
  monitor: {
    dataStatistics: '数据统计',
    historyData: '历史数据统计',
    historyChargeData: '历史充电与放电量',
    historyPower: '历史供电时长',
    historyLightingTime: '历史亮灯时长',
    monthWeather: '按月统计天气情况'
  },
  // 分组
  group: {
    groupList: '分组列表',
    noGroup: '未分组',
    editGroup: '编辑分组',
    createGroup: '请新建分组',
    viewStrategy: '查看策略',
    setStrategy: '下发策略',
    moveTo: '移动到',
    filterGruop: '筛选分组',
    moveToGroup: '请移动设备到该分组',
    addDevice: '请添加设备',
    groupName: '分组名',
    addGroup: '添加分组',
    selectStrategy: '请选择策略',
    strategyToGroup: '确定对该分组下发策略?',
    groupNoStrategy: '该分组暂无应用的策略',
    noData: '暂无'
  },
  // 设备中心
  device: {
    toWarn: '前往告警中心',
    overView: '设备总览',
    toList: '切换到列表模式',
    toMap: '切换到地图模式',
    icon: '图示',
    waitRenderMap: '若同一经纬度下有大量设备，可能导致地图渲染较慢，请耐心等待！',
    changeCoordinates: '更改坐标',
    updateFaile: '更新失败，设备的上次更新时间为',
    updateAgain: '重新更新？',
    changeMapLocation: '拖动地图中的设备进行位置更改！',
    noResponse: '设备无响应',
    ledInfo: '电压/电流/功率',
    solarInfo: '太阳能板电压/电流/功率',
    batteryInfo: '电池电压/电流/功率',
    openHumanFlow: '开启人流控',
    closeHumanFlow: '关闭人流控',
    setPowerSupply: '切换电源电压',
    setIntelligentPower: '智能功率设置',
    setZeroCharge: '零度充电方式',
    chargeMode: '充电方式',
    faileDevices: '更新失败设备',
    baseInfo: '基本信息',
    operationRecord: '操作记录',
    paramsTime: '参数下发时间',
    strategyIssueStatus: '策略下发状态',
    isSettedParam: '参数下发状态',
    notIssued: '未下发',
    alreadyIssued: '已下发',
    currentGainTime: '当前获取时间',
    intelligenceStrategy: '智能策略',
    strategyTime: '策略下发时间',
    tiemPeriod: '策略时间段',
    at: 'at'
  },
  // 充值中心
  voucher: {
    voucherCenter: '充值中心',
    commodity: '商品管理',
    order: '订单管理',
    setting: '设置',
    backHome: '回到首页',
    allStatus: '全部状态',
    completed: '已完成',
    paid: '已支付',
    refunding: '退款中',
    refunded: '已退款',
    refundFailed: '退款失败',
    paymentFailure: '支付失败',
    waittingPayment: '待支付',
    searchOrderId: '搜索订单号',
    orderId: '订单号:',
    noOrder: '暂无订单',
    information: '商品信息',
    price: '单价(元)',
    rechargeCount: '数量(件)',
    payAmount: '支付金额',
    buyer: '买家',
    payTime: '支付时间',
    orderStatus: '订单状态',
    operation: '操作',
    deviceList: '设备列表',
    export: '导出Excel',
    rechargeCompleted: '充值完成',
    completionTime: '完成时间:',
    deviceName: '设备名称',
    sn: 'SN号',
    sim: 'SIM卡号',
    rechargeStatus: '充值状态',
    rechargeSucceeded: '充值成功',
    charging: '充值中',
    rechargeFailed: '充值失败',
    cancelled: '已取消',
    confirmation: '充值完成确认',
    comfirmContent: '您确定该订单已经充值完成了吗？',
    comfirmTips: '该操作无法更改，请谨慎操作！',
    comfirmRefund: '您确定退款该订单吗？',
    refund: '退款',
    handlingMethod: '处理方式',
    processingResults: '处理结果',
    completeRefund: '退款完成',
    cancelRefund: '取消退款',
    name: '商品名称',
    type: '商品类型',
    state: '商品状态',
    addCommodity: '新增商品',
    editCommodity: '编辑商品',
    edit: '编辑',
    itemDownshelf: '下架',
    ItemUpshelf: '上架',
    tips: '提示',
    itemDownshelfTips: '此操作将下架该商品, 是否继续?',
    itemUpshelfTips: '此操作将上架该商品, 是否继续?',
    dellteTips: '此操作将永久删除该商品, 是否继续?',
    namePlaceholder: '请输入商品名称',
    monthlyFlow: '每月流量',
    flow: '流量',
    flowMonth: '时长',
    sixMonths: '6个月',
    twelveMonths: '12个月',
    twentyFourMonths: '24个月',
    priceNoUnit: '价格',
    unit: '元',
    submit: '提交',
    operationSuccess: '操作成功',
    operationCancelled: '操作已取消',
    itemDownshelfSuccess: '下架成功',
    itemDownshelfCancelled: '已取消下架',
    itemUpshelfSuccess: '上架成功',
    itemUpshelfCancelled: '已取消上架',
    deleteSuccess: '删除成功',
    deleteCancelled: '已取消删除',
    addSuccess: '新增成功',
    addFailure: '新增失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败'
  },
  // 验证规则
  rules: {
    selectRechargeType: '请选择充值类型',
    enterProductName: '请输入商品名称',
    enterPackageDuration: '请输入套餐时长',
    cannotEmpty: '数值不能为空',
    enterNumericValue: '请输入数字值',
    enterValueGreaterZero: '请输入大于0的值'
  }
}
